export const catRoles = Object.freeze({
    NoAplica: 0,
    ADMINISTRADOR: 1,
    DEVELOPER: 9
})